/*
 * Copyright (C) 2017 Spanning Cloud Apps LLC. All rights reserved.
 */
import './saveModal.tpl.html';

/**
 * Module for the confirm modal.
 */
angular
  .module('bulkExport.saveModal', [])
  /**
   * Confirm Modal controller. Controller for the saveModal.tpl.html template.
   */
  .controller('SaveModalCtrl', [
    '$scope',
    '$filter',
    '$uibModalInstance',
    'presets',
    'presetName',
    function ($scope, $filter, $uibModalInstance, presets, presetName) {
      // If there's no name we're saving from "create new".
      // If there's a name we're saving from an existing preset.
      var originalName = presetName;
      $scope.name = presetName;

      /**
       * Determines whether the current name matches an existing preset other than the one being edited.
       *
       * @returns {boolean} true if the current name matches an existing preset other than the one being edited.
       */
      $scope.isExistingPresetName = function () {
        // If there's no original name we're creating a new preset, so we always want to check the name.
        // If there's an original name we allow that one to be overwritten
        if (originalName && $scope.name === originalName) {
          return false;
        }

        return !!_.find(presets, function (preset) {
          return preset.name === $scope.name;
        });
      };

      /**
       * Determines whether we're creating a new preset.
       *
       * @returns {boolean} true if we're creating a new preset, false otherwise
       */
      $scope.isNewPreset = function () {
        // If there's no original name we're creating a new preset
        return !originalName;
      };

      /**
       * Function to cancel out of the model.
       */
      $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
      };

      /**
       * Function called when confirm is clicked.
       * Will return true to the parent window, which means to exit wizard flow.
       */
      $scope.confirm = function () {
        $uibModalInstance.close({ confirmed: true, presetName: $scope.name });
      };
    }
  ]);
